export default class InternalLinks {

  constructor () {

  }

  isOnFirstPage () {

  }

}



// WEBPACK FOOTER //
// ./resources/js/modules/internal-links/index.js